<script lang="ts" setup>
import { computed } from 'vue'
import {
  IconActionAddLarge,
  IconActionAddSmall,
  IconGeneralGrid2X2,
  IconGeneralGrid2X2Small,
} from '@cypress-design/vue-icon'

const props = withDefaults(
  defineProps<{
    dark?: boolean
    size?: 'sm' | 'lg'
    purple?: boolean
  }>(),
  {
    dark: false,
    size: 'sm',
  },
)

const strokeColor = computed(() => (props.dark ? 'gray-700' : props.purple ? 'purple-500' : 'gray-200'))
/*
<windi-keep
  stroke-color="gray-700"
  stroke-color="gray-200"
  stroke-color="purple-400"
/>
 */
</script>

<template>
  <div
    class="flex"
    :class="{
      'gap-[8px]': size === 'sm',
      'gap-[16px]': size === 'lg',
    }"
  >
    <template v-if="size === 'sm'">
      <IconActionAddSmall :stroke-color="strokeColor" />
      <IconGeneralGrid2X2Small :stroke-color="strokeColor" fill-color="transparent" />
    </template>
    <template v-else>
      <IconActionAddLarge :stroke-color="strokeColor" />
      <IconGeneralGrid2X2 :stroke-color="strokeColor" fill-color="transparent" />
    </template>
  </div>
</template>
